<template>
  <div class="logisticsView">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ $t('logistics.logisticsView.logisticsViewOrder') }}
          </div>
        </template>
        <div class="collapse-content">
          <logistics-receipt
            v-bind:logisticsData="logisticsData"
            v-bind:canEdit="true"
            ref="logisticsData"
          ></logistics-receipt>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ $t('logistics.logisticsView.baseInformation') }}
          </div>
        </template>
        <div class="collapse-content">
          <base-information
            logisticsData="logisticsData"
            v-bind:baseData.sync="baseData"
            v-bind:canEdit="true"
            ref="baseDataInformation"
            @storageChange="storageChange"
          ></base-information>
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ $t('logistics.logisticsView.costFree') }}
          </div>
        </template>
        <div class="collapse-content">
          <cost-free v-bind:costData="costData" v-bind:canEdit="true" ref="costData"></cost-free>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="common-tab tab">
      <el-tabs v-model="activeName" type="border-card">
        <el-tab-pane :label="$t('logistics.logisticsView.priductRowList')" name="1">
          <div class="tabArea">
            <commodity-market
              v-bind:commodityMarketData="commodityMarketData"
              :upstreamType.sync="upstreamType"
              ref="commodityMarketView"
            ></commodity-market>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('logistics.logisticsView.costView')" name="2">
          <div class="tabArea">
            <detailsof-Charges
              :costType="costType"
              v-bind:detailsOfChargesData="detailsOfChargesData"
              ref="detailsOfCharges"
            ></detailsof-Charges>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('logistics.logisticsView.transportationInformation')" name="3">
          <div class="tabArea">
            <transportation-information
              v-bind:transportationInformationData="transportationInformationData"
              :shippingMethod.sync="shippingMethod"
              ref="transportationInformation"
            ></transportation-information>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog :title="$t('logistics.logisticsView.copyFiles')" :visible.sync="dialogTableVisible">
      <vxe-grid
        border
        resizable
        :auto-resize="true"
        show-overflow
        ref="fileTable"
        :data="distributionAttachment"
      >
        <vxe-table-column
          type="index"
          :title="$t('logistics.logisticsView.index')"
        ></vxe-table-column>
        <vxe-table-column
          field="attachmentName"
          :title="$t('logistics.logisticsView.attachmentName')"
        ></vxe-table-column>
        <vxe-table-column
          field="gmtCreate"
          :title="$t('logistics.logisticsView.gmtCreate')"
        ></vxe-table-column>
        <vxe-table-column
          field="createBy"
          :title="$t('logistics.logisticsView.createBy')"
        ></vxe-table-column>
        <vxe-table-column :title="$t('logistics.logisticsView.doShow')">
          <template v-slot="{ row }">
            <vxe-button type="text" @click="downLode(row)">{{
              $t('logistics.logisticsView.downLode')
            }}</vxe-button>
          </template>
        </vxe-table-column>
      </vxe-grid>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">{{
          $t('logistics.logisticsView.close')
        }}</el-button>
        <el-button type="primary" @click="dialogTableVisible = false">{{
          $t('logistics.logisticsView.sure')
        }}</el-button>
      </div>
    </el-dialog>
    <div class="fixed-bottom-btnList">
      <!-- 撤销 -->
      <el-button
        class="fixed-bottom-btn"
        type="primary"
        :disabled="logisticsData.inboundStatus != '02' || logisticsData.inboundType == 'RK05'"
        @click="save('03')"
        v-hasPermi="['2021050814344523387']"
        >{{ $t('logistics.logisticsView.pleaseGetUp') }}</el-button
      >
      <!-- 保存 -->
      <el-button
        class="fixed-bottom-btn"
        type="primary"
        :disabled="logisticsData.inboundStatus == '02'"
        @click="save('01')"
        v-hasPermi="['2021050814350381045']"
        >{{ $t('logistics.logisticsView.save') }}</el-button
      >
      <!-- 提交 -->
      <el-button
        class="fixed-bottom-btn"
        type="primary"
        :disabled="logisticsData.inboundStatus == '02'"
        @click="save('02', 'Y')"
        v-hasPermi="['2021050814345491832']"
        >{{ $t('logistics.logisticsView.submit') }}</el-button
      >
      <!-- 上传附件 -->
      <el-button
        class="fixed-bottom-btn"
        type="primary"
        @click="isEdit = true"
        v-hasPermi="['2021050814364861764']"
        v-if="logisticsData.inboundStatus != '02'"
        >{{ $t('logistics.logisticsView.exportFiles') }}</el-button
      >
      <!-- 下载附件 -->
      <el-button
        class="fixed-bottom-btn"
        type="primary"
        @click="dialogTableVisible = true"
        v-hasPermi="['2021050814363837673']"
        v-else
        >{{ $t('logistics.logisticsView.downLodeFiles') }}</el-button
      >
      <!-- 删除 -->
      <el-button
        class="fixed-bottom-btn"
        type="primary"
        :disabled="['02'].includes(logisticsData.inboundStatus)"
        @click="deletDetail"
        v-hasPermi="['2021050814370994502']"
        >{{ $t('logistics.logisticsView.delete') }}</el-button
      >
    </div>
    <!-- 打印 -->
    <el-dialog :title="$t('logistics.logisticsView.copyFiles')" :visible.sync="isEdit">
      <upload
        ref="upload"
        @upload="uploadFile"
        v-bind:tableData="distributionAttachment"
        v-bind:isShow="canEdit"
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click="isEdit = false">{{ $t('logistics.logisticsView.close') }}</el-button>
        <el-button type="primary" @click="isEdit = false">{{
          $t('logistics.logisticsView.sure')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/logisticsCenter/logisticsReceiptList.js';
  import LogisticsReceipt from './components/logisticsReceipt';
  import BaseInformation from './components/baseInformation';
  import CostFree from './components/costFree';
  import CommodityMarket from './components/commodityMarketView';
  import DetailsofCharges from './components/detailsOfCharges';
  import TransportationInformation from './components/transportationInformationView';
  import upload from '@/components/upload';
  export default {
    name: 'logisticsView',
    components: {
      LogisticsReceipt,
      BaseInformation,
      CostFree,
      CommodityMarket,
      DetailsofCharges,
      TransportationInformation,
      upload,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    data() {
      // let newDate = new Date();
      return {
        isEdit: false,
        load: false,
        activeNames: ['1', '2', '3', '4', '5', '6'], //默认展开那些面板，
        //物流信息
        logisticsData: {
          inboundStatus: '', //状态
          inboundCreatePerson: '', //制单人名称
          createDate: '', //创建日期
          inboundNo: '', //物流单号
          companyCode: '', //公司编号
          companyName: '', //公司名称
          inboundType: '', //入库类型
        },
        // 基本信息
        baseData: {
          partnerNo: '', //供应商编码
          partnerName: '', //供应商名称
          partnerNoList: { pickupStorageName: '', partnerCode: '' }, //供应商回显
          storageName: '', //仓库名称
          storageNo: '', //仓库代码
          storageNoList: { deliverToStorageNo: '', deliverToStorageName: '' }, //仓库回显
          entrustingPartyName: '', //委托方名称
          entrustingPartyNo: '', //委托方代码
          entrustingPartyList: {
            deliverToStorageNo: '',
            deliverToStorageName: '',
          },
          marineBillOfLadingNo: '', //海运提单号
          nameLot: '', //船名/批次
          salesmanNo: '', //业务员编码
          salesmanName: '', //业务员名称
          salesmanNoList: { salesmanNo: '', salesmanName: '' },
          inboundDepartmentNo: '', //部门编码
          inboundDepartmentName: '', //部门名称
          inboundDate: '', //入库日期
          inboundType: '', //入库类型
          businessProperty: '', //业务性质
          avoidBoxDate: '', //免箱期至
          shippingMark: '', //备注
          externalNo: '', //外部编码
        },
        // 费用
        costData: {
          totalExpense: '', //费用
          currencyTypeName: '', //币种
          currencyTypeCode: '',
          settleDate: '', //结算日期
          settlePersonName: '', //结算人员姓名
          settleNo: '', //结算单号
          settled: false, //标识
        },
        //商品行项目表格
        commodityMarketData: [],
        //费用详情表格
        detailsOfChargesData: [],
        //运输信息表格
        transportationInformationData: [],
        //附件table
        distributionAttachment: [],
        costType: [], //费率类型
        shippingMethod: { shippingMethod: '' }, //运输方式
        activeName: '1',
        version: '', //版本号
        dialogTableVisible: false,
        upstreamType: 1, //来源
        attachmentList: [],
        canEdit: true,
      };
    },
    mounted() {
      this.getDate();
      this.getCostType();
    },
    methods: {
      uploadFile(value) {
        this.distributionAttachment = value;
      },
      //收货仓库改变
      storageChange(val) {
        this.$refs.commodityMarketView.getTableData().forEach((item) => {
          item.storageNo = val.storageNo;
          item.storageName = val.storageName;
        });
        this.commodityMarketData = this.$refs.commodityMarketView.getTableData();
      },
      getDate() {
        let arr = ['logisticsData', 'baseData', 'costData'];
        let params = {
          inboundNo: this.$route.query.inboundNo,
          shippingInstructionNo: this.$route.query.shippingInstructionNo,
        };
        this.loading.startLoading();
        this.$axios.get(API.GETDISTRIBUTIONINBOUND_DATA_API, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code == 0) {
            for (let item of Object.keys(res.data.data)) {
              for (let objName of arr) {
                if (Object.keys(this[objName]).includes(item)) {
                  this[objName][item] = res.data.data[item];
                }
              }
            }
            //供应商按钮进来后，基本信息操作
            this.baseData.entrustingPartyList = {
              deliverToStorageNo: res.data.data.entrustingPartyNo,
              deliverToStorageName: res.data.data.entrustingPartyName,
            };
            this.baseData.storageNoList = {
              deliverToStorageNo: res.data.data.storageNo,
              deliverToStorageName: res.data.data.storageName,
            };
            this.baseData.partnerNoList = {
              partnerCode: res.data.data.partnerNo,
              pickupStorageName: res.data.data.partnerName,
            };
            this.baseData.salesmanNoList = {
              salesmanNo: res.data.data.salesmanNo,
              salesmanName: res.data.data.salesmanName,
            };
            this.baseData.marineBillOfLadingNo = res.data.data.marineBillOfLadingNo;
            this.baseData.storageNo = res.data.data.storageNo;
            this.baseData.partnerNo = res.data.data.partnerNo;
            this.baseData.entrustingPartyNo = res.data.data.deliverToStorageNo;
            this.logisticsData.inboundCreatePersonName = res.data.data.inboundCreatePersonName;
            this.logisticsData.inboundCreatePersonNo = res.data.data.inboundCreatePersonNo;
            this.logisticsData.companyName = res.data.data.companyName;
            this.logisticsData.companyCode = res.data.data.companyCode;
            this.logisticsData.inboundType = res.data.data.inboundType;
            if (res.data.data.settled == 0) {
              this.costData.settled = false;
            } else {
              this.costData.settled = true;
            }
            this.commodityMarketData = res.data.data.distributionInboundProducts;
            console.log(this.commodityMarketData);
            this.commodityMarketData.forEach((item) => {
              if (res.data.data.upstreamType == 1) {
                item.partnerCode = this.baseData.partnerCode;
                item.partnerName = this.baseData.partnerName;
                item.instructionDetailNo = item.shippingInstructionRowNo;
              } else if (
                res.data.data.upstreamType == 2 ||
                res.data.data.upstreamType == 3 ||
                res.data.data.upstreamType == 4 ||
                res.data.data.upstreamType == 5
              ) {
                item.instructionNumber = item.businessConfirmQuantity;
              }
            });
            //  指令数量小于0不能展示
            this.commodityMarketData = this.commodityMarketData.filter((item) => {
              return Number(item.instructionNumber) > 0;
            });
            this.transportationInformationData = res.data.data.distributionInboundShippings;
            this.detailsOfChargesData = res.data.data.distributionInboundExpenses;
            this.distributionAttachment = res.data.data.distributionAttachments;
            //运输方式
            this.shippingMethod.shippingMethod = res.data.data.shippingMethod;
            this.instructionNo = res.data.data.instructionNo;
            this.version = res.data.data.version;
            this.upstreamType = res.data.data.upstreamType;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //删除
      deletDetail() {
        this.$confirmAction()
          .then(() => {
            let params = {
              inboundNo: this.$route.query.inboundNo,
              shippingInstructionNo: this.$route.query.shippingInstructionNo,
              version: this.version,
            };
            this.$axios.post(API.DELETDISTRIBUTIONINBOUND_DATA_API, params).then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'success',
                });
                this.toList();
              } else {
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      // 保存,撤销,提交
      save(val) {
        if (val == '02') {
          let value = this.$refs.baseDataInformation.getVal();
          if (value != false) {
            Promise.resolve(this.$refs.detailsOfCharges.fullValidEvent()).then((r) => {
              if (r) {
                Promise.resolve(this.$refs.commodityMarketView.fullValidEvent()).then((flag) => {
                  if (flag) {
                    const data = flag.commodityMarketData;
                    let inboundQuantityFlag = true; // 物流入库数量
                    data.forEach((item) => {
                      if (Number(item.inboundQuantity) < 0) {
                        inboundQuantityFlag = false;
                      }
                    });
                    if (inboundQuantityFlag) {
                      this.saveIng(val);
                    } else {
                      //剩余可以小于零，如果是负数不能带入入库数量，且提交要校验入库数量不能负数
                      this.$message({
                        showClose: true,
                        message: this.$t('logistics.logisticsView.inboundQuantityNegativeNum'),
                        type: 'error',
                      });
                    }
                  } else {
                    this.$message({
                      showClose: true,
                      message: this.$t('logistics.logisticsView.pleaseAddProudectRow'),
                      type: 'error',
                    });
                  }
                });
              } else {
                this.$message({
                  showClose: true,
                  message: this.$t('logistics.logisticsView.pleaseAddCostRow'),
                  type: 'error',
                });
              }
            });
          }
        } else {
          this.saveIng(val);
        }
      },
      saveIng(val, submitCheck = 'Y') {
        let logisticsData = this.$refs.logisticsData.getSaveVal();
        let costData = this.$refs.costData.getSaveVal();
        this.$delete(costData, 'settled'); //删除标识属性
        let baseData = this.$refs.baseDataInformation.getSaveVal();
        let commodityMarketData = this.$refs.commodityMarketView.getSaveVal();
        let detailsOfChargesData = this.$refs.detailsOfCharges.getSaveVal().detailsOfChargesData;
        let transportationInformation = this.$refs.transportationInformation.getSaveVal();
        let params = Object.assign({}, logisticsData, baseData, costData);
        // params.totalExpense = costData.totalExpense;
        // params.currencyType = costData.currencyType;
        if (typeof baseData.entrustingParty == 'object') {
          params.entrustingPartyNo = baseData.entrustingParty[0].partnerCode;
          params.entrustingPartyName = baseData.entrustingParty[0].partnerZhName;
        }
        if (typeof baseData.partnerNo == 'object') {
          params.partnerNo = baseData.partnerNo[0].partnerCode;
          params.partnerName = baseData.partnerNo[0].partnerZhName;
        }
        if (typeof baseData.storageNo == 'object') {
          params.storageNo = baseData.storageNo[0].storageCode;
          params.storageName = baseData.storageNo[0].storageName;
        }
        if (typeof baseData.salesmanNo == 'object' && baseData.salesmanNo != null) {
          params.salesmanNo = baseData.salesmanNo[0].personNo;
          params.salesmanName = baseData.salesmanNo[0].personName;
        }
        // params.createDate = this.getTime(this.logisticsData.createDate);
        params.version = this.version;
        params.upstreamType = this.upstreamType; //三种指令，传死值
        params.shippingInstructionNo = this.$route.query.shippingInstructionNo;
        params.distributionAttachments = this.distributionAttachment;
        params.distributionInboundProducts = commodityMarketData;
        params.distributionInboundExpenses = detailsOfChargesData;
        params.distributionInboundShippings =
          transportationInformation.transportationInformationData;
        params.shippingMethod = transportationInformation.shippingMethod.shippingMethod;
        params.departmentCode = this.userInfo.userInfo.departmentCode;
        params.departmentName = this.userInfo.userInfo.departmentName;
        this.loading.startLoading();
        let url = API.SAVADISTRIBUTIONINBOUND_DATA_API;
        if (val == '01') {
          url = API.SAVADISTRIBUTIONINBOUND_DATA_API;
        } else if (val == '02') {
          url = API.SUBMIT_DISTRIBUTIONINBOUND_DATA_API;
          params.submitCheck = submitCheck;
        } else if (val == '03') {
          url = API.UNDO_DISTRIBUTIONINBOUND_DATA_API;
        }
        this.$axios.post(url, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            if (val == '03') {
              this.getDate();
            } else if (val == '01') {
              this.getDate();
            } else {
              this.toList();
            }
          } else if (res.data.code == 9) {
            // 提交时校验软提示
            this.$confirmAction('提示', res.data.msg)
              .then(() => {
                this.saveIng(val, 'N');
              })
              .catch(() => {
                this.getDate();
              });
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      downLode(val) {
        console.log(val);
        window.location.href = val.attachmentPath;
      },
      //跳转
      toList() {
        let pathList = {
          fromPath: {
            path: '/logistics/logisticsView',
            name: 'logisticsView',
            meta: {
              keepAlive: true,
              title: this.$t('logistics.logisticsReceiptList.logisticsView'),
            },
          },
          toPath: {
            path: '/logistics/logisticsReceiptList',
            name: 'logisticsReceiptList',
            meta: {
              keepAlive: false,
              title: this.$t('logistics.logisticsView.logisticsReceiptList'),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
      //获取费用类型
      async getCostType() {
        let params = {
          // dictType: "expense_type",
          dictType: 'logistics_expense_type',
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_DICTBYDATACODE, params);
        if (selectStatus.data.code == 0) {
          this.costType = selectStatus.data.data;
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .logisticsView .tab {
    margin-top: 10px;
    margin-bottom: 90px;
  }
  .logisticsView .bottomBtn {
    text-align: center;
    padding: 20px;
  }
  .logisticsView .bottomBtn .saveBtn {
    width: 100px;
  }
  .logisticsView .collapse-main-content {
    padding-bottom: 0px !important;
  }
  .logisticsView .el-dialog__header {
    padding: 14px 16px;
    border-bottom: 1px solid #e8eaec;
    background: #5391da;
    text-align: center;
  }
  .logisticsView .el-dialog__title {
    line-height: 24px;
    font-size: 18px;
    color: white !important;
  }
  .logisticsView .el-dialog__headerbtn {
    top: 10px;
  }
  .logisticsView .el-icon-close:before {
    content: '\E6DB';
    color: white;
    font-size: 30px;
  }
  .logisticsView .el-dialog {
    width: 800px;
  }
  .logisticsView .tabArea {
    box-sizing: border-box;
    padding: 20px;
    padding-top: 10px;
  }
</style>
